import { passkeyClient } from "@better-auth/passkey/client";
import { ssoClient } from "@better-auth/sso/client";
import {
	adminClient,
	inferAdditionalFields,
	magicLinkClient,
	organizationClient,
	twoFactorClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import type { auth } from ".";

export const authClient = createAuthClient({
	plugins: [
		inferAdditionalFields<typeof auth>(),
		magicLinkClient(),
		organizationClient(),
		adminClient(),
		passkeyClient(),
		// Adds `authClient.signIn.sso(...)`, used by the email-first login flow
		// once an address resolves to an organization's identity provider.
		ssoClient(),
		// Adds `authClient.twoFactor.{enable,disable,verifyTotp,
		// verifyBackupCode,getTotpUri,generateBackupCodes}`.
		//
		// Deliberately configured with neither `twoFactorPage` nor
		// `onTwoFactorRedirect`: both turn the plugin's fetch hook into a
		// *global* navigation whenever any response carries
		// `twoFactorRedirect`, which would hijack non-interactive callers.
		// LoginForm handles `data.twoFactorRedirect` on the sign-in result
		// itself and renders its own TOTP step instead.
		twoFactorClient(),
	],
});

export type AuthClientErrorCodes = typeof authClient.$ERROR_CODES & {
	INVALID_INVITATION: string;
};
